import React from 'react';
import Component from '@vfuk/core-search-suggestion-with-label';
const SearchSuggestionWithLabel = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default SearchSuggestionWithLabel;
